import { TFunction } from 'react-i18next';
import { RegionsContainer, PickupContainer } from '../containers';

export enum RegionsAndPickupTabs {
  REGIONS = 'regions',
  PICKUP = 'pickup',
}

export const getRegionsAndPickupTabsConfig = (t: TFunction) => [
  {
    label: t('regions_tab_title'),
    key: RegionsAndPickupTabs.REGIONS,
    content: <RegionsContainer />,
  },
  {
    label: t('pickup_tab_title'),
    key: RegionsAndPickupTabs.PICKUP,
    content: <PickupContainer />,
  },
];
